export const INTERNET_PROMOTION_LINK = 'https://www.wecasa.fr/autorisation-promotion-internet';
export const SIREN_REGISTRATION_LINK = 'https://survey.zohopublic.com/zs/Y8ChC9';
